// extracted by mini-css-extract-plugin
export default {"status":"TransactionStatus_status__f5Uxj","status_text":"TransactionStatus_status_text__rx+MP"};